import { _env } from "@/lib/funifier-env";
import { funifierApi } from "./api";

export async function getPartners() {
  try {
    console.log(_env.FUNIFIER_ENV?.apikey);
    if (!_env.FUNIFIER_ENV?.apikey) return;
    const { data } = await funifierApi.post("/find/partners", {}, {
      headers: {
        "Authorization": `Basic ${btoa(_env.FUNIFIER_ENV?.apikey || "")}`,
      },
    });
    return data;
  } catch (err) {
    return [];
  }
}